export { default, useDefaultProps } from './DefaultPropsProvider';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/DefaultPropsProvider/index.js
// module id = 761
// module chunks = 22